export const HELP_CENTER_LINK = 'https://help.hover.to/en/';
export const HOVER_COMMUNITY_LINK = 'https://community.hover.to';
export const HOVER_DOWNLOAD_APP_LINK =
  'https://apps.apple.com/us/app/hover-measurements-in-3d/id942568673';
export const HOVER_LINKEDIN_LINK =
  'https://www.linkedin.com/company/hover-inc-/';
export const HOVER_YOUTUBE_LINK = 'https://www.youtube.com/hover3d';
export const HOVER_FACEBOOK_LINK = 'https://www.facebook.com/hover3d/';
export const HOVER_TWITTER_LINK = 'https://twitter.com/hover3d';
export const HOVER_APPLE_DOWNLOAD_LINK =
  'https://apps.apple.com/us/app/hover-3d-building-visualization/id942568673';
export const HOVER_ANDROID_DOWNLOAD_LINK =
  'https://play.google.com/store/apps/details?id=to.hover.android.app&hl=en';
export const AICPA_LINK =
  'https://us.aicpa.org/interestareas/frc/assuranceadvisoryservices/aicpasoc2report';
export const AMSTILL_ROOFING_LINK =
  'https://hover.to/blog/how-amstill-roofing-leverages-hover-to-scale-their-business/';
export const ACTIVATE_THE_NEW_CONSTRUCTION_SOLUTION_LINK =
  'https://form.jotform.com/221865275519161';
